import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ss-tamanho-completo" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-17" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Fornecedor")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Identificação/Código produto")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Principal")
  ])
], -1)
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-17" }
const _hoisted_8 = { class: "ss-margin-campos" }
const _hoisted_9 = { class: "ant-col ant-col-xs-16 ant-col-xl-5" }
const _hoisted_10 = { class: "ss-margin-campos" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "ant-col ant-col-xs-5 ant-col-xl-1 ss-alinhar-centro" }
const _hoisted_13 = { class: "ant-col ant-col-xs-3 ant-col-xl-1 ss-alinhar-centro" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_selecionar_fornecedor = _resolveComponent("selecionar-fornecedor")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.props.empresas.length <= 0)
      ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
          key: 0,
          mensagem: "É necessário selecionar uma empresa antes de definir os fornecedores"
        }))
      : (_openBlock(), _createBlock(_component_a_form, {
          key: 1,
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_form_item, {
                  label: "Fornecedor",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_fornecedor, {
                      ref: "campoNovoFornecedor",
                      codigoSelecionado: _ctx.state.novoFornecedor.codigoFornecedor,
                      "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.novoFornecedor.codigoFornecedor) = $event)),
                      empresas: _ctx.props.empresas,
                      apresentarCpfCnpj: true
                    }, null, 8, ["codigoSelecionado", "empresas"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_form_item, {
                  label: "Identificação/Código produto",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      ref: "campoCodigoNovoFornecedor",
                      class: "ant-input",
                      maxlength: "100",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.novoFornecedor.identificador) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.novoFornecedor.identificador]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_form_item, {
                  label: " ",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-secondary ant-btn-block",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adicionarFornecedor()))
                    }, " Adicionar ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_6,
            (_ctx.computedFornecedores.length <= 0)
              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                  key: 0,
                  mensagem: "Nenhuma fornecedor foi adicionado ainda"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form, {
              name: "ss-form-produto-fornecedores",
              class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal",
              model: _ctx.computedFornecedores
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedFornecedores, (produtoFornecedor, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "ant-row ss-grade-personalizada-linha",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_selecionar_fornecedor, {
                          codigoSelecionado: produtoFornecedor.codigoFornecedor,
                          "onUpdate:codigoSelecionado": ($event: any) => ((produtoFornecedor.codigoFornecedor) = $event),
                          empresas: _ctx.props.empresas,
                          apresentarCpfCnpj: true,
                          limparSelecao: false
                        }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "empresas"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "100",
                          class: "ant-input",
                          "onUpdate:modelValue": ($event: any) => ((produtoFornecedor.identificador) = $event)
                        }, null, 8, _hoisted_11), [
                          [_vModelText, produtoFornecedor.identificador]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_checkbox, {
                        checked: produtoFornecedor.principal,
                        "onUpdate:checked": ($event: any) => ((produtoFornecedor.principal) = $event),
                        onChange: ($event: any) => (_ctx.defineApenasUmPrincipal(index,$event.target.checked,false)),
                        class: "ss-checkbox-grande"
                      }, null, 8, ["checked", "onUpdate:checked", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-secondary",
                        onClick: ($event: any) => (_ctx.removerFornecedor(index))
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_14)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }))
  ]))
}